import React, { useState } from 'react';
import { useRouter } from 'next/router';
import styled from 'styled-components';
import { MembershipApplication } from 'store/membership/type';
import { useDispatch } from 'react-redux';
import { membershipActions } from 'store/membership';
import { useSelector } from 'store';
import useFromSeogyo from 'hooks/useFromSeogyo';
import Modal from 'components/common/Modal';
import ModalTerms from 'components/Popup/ModalTerms';
import { GetTermsAPI } from 'api/site';
import { siteActions } from 'store/site';

const MembershipRegisterService: React.FC = () => {
  const router = useRouter();
  const dispatch = useDispatch();
  const { openModal, ModalPortal, closeModal } = Modal();

  // [필수 안내] 멤버십 가입 개인정보 수집·이용 안내 — 단순 고지, 보기 클릭 시 모달
  const openTerms = async (type: string) => {
    const { data } = await GetTermsAPI(type);
    dispatch(siteActions.getTerm(data));
    openModal();
  };

  const { isFromSeogyo } = useFromSeogyo(router.query);
  const membershipServices = useSelector(state => {
    if (isFromSeogyo) {
      return state.service.membershipService.filter(item =>
        item.name.includes('서교'),
      );
    }

    return state.service.membershipService;
  });

  const [selectedMembership, setSelectedMembership] = useState(-1);

  const clickNext = () => {
    if (selectedMembership === -1) {
      alert('신청할 멤버십 서비스를 선택해주세요.');
      return;
    }

    const membership: MembershipApplication = {
      membership_service: selectedMembership.toString(),
    };

    dispatch(membershipActions.setMembershipInfo(membership));

    const selectedServices = membershipServices.filter(
      service =>
        service.id === selectedMembership && service.name.includes('서교'),
    );

    if (!isFromSeogyo && selectedServices.length > 0) {
      const params = window.location.search
        ? `${window.location.search}&from=seogyo`
        : '?from=seogyo';
      router.push(`/membership/join/setbasicinfo${params}`);
    }

    router.push(`/membership/join/setbasicinfo${window.location.search}`);
  };

  return (
    <>
    <div className="cnts-wrap">
      <div className="membership-join">
        <h2>멤버십 가입신청</h2>
        <div className="step">
          <ol>
            <li>
              <strong>멤버십 선택</strong>
            </li>
            <li>기본정보 입력</li>
            {!isFromSeogyo && <li>추가정보 입력</li>}
            <li>결제정보 입력</li>
            <li>신청완료</li>
          </ol>
        </div>
        <div className="cnts">
          <div className="sett-info">
            <div className="top-info">
              <div className="hgroup">
                <h3>신청할 멤버십 서비스를 선택해주세요.</h3>
              </div>
            </div>
            {membershipServices.map(
              ({ id, name, short_description, price }) => (
                <MembershipItem
                  key={id}
                  onClick={() => setSelectedMembership(id)}
                  style={{ borderWidth: id === selectedMembership ? 3 : 1 }}
                >
                  <div className="wrapper">
                    <div className="title">{name}</div>
                    <div className="description">{short_description}</div>
                  </div>
                  <div className="price">{`${Number(price).toLocaleString(
                    'ko-KR',
                  )} 원/월`}</div>
                </MembershipItem>
              ),
            )}
          </div>
          <AgreeNotice>
            <span>[필수 안내] 멤버십 가입 개인정보 수집·이용 안내</span>
            <a
              onClick={() => openTerms('memberhipsterms')}
              style={{ cursor: 'pointer' }}
            >
              보기
            </a>
          </AgreeNotice>
          <div className="btn-def">
            <a onClick={clickNext} style={{ cursor: 'pointer' }}>
              다음
            </a>
          </div>
        </div>
      </div>
    </div>
    <ModalPortal>
      <ModalTerms closeModal={closeModal} />
    </ModalPortal>
    </>
  );
};

const AgreeNotice = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 20px;
  font-size: 15px;

  a {
    text-decoration: underline;
    cursor: pointer;
  }
`;

const MembershipItem = styled.div`
  display: flex;
  align-items: center;
  padding: 24px 16px;
  margin-top: 12px;
  border: 1px solid #111;
  cursor: pointer;
  @media screen and (max-width: 786px) {
    flex-direction: column;
    align-items: flex-start;
  }

  .wrapper {
    flex: 1;
  }

  .title {
    font-size: 24px;
    font-weight: bold;
    @media screen and (max-width: 786px) {
      font-size: 20px;
    }
  }

  .description {
    max-width: 70%;
    font-size: 16px;
    margin-top: 12px;
    @media screen and (max-width: 786px) {
      font-size: 15px;
    }
  }

  .price {
    font-size: 30px;
    @media screen and (max-width: 786px) {
      margin-top: 12px;
      font-size: 24px;
    }
  }
`;

export default MembershipRegisterService;
